import React from "react";


function YesNoFieldRenderer(props) {
  const current =
    props.value && typeof props.value.bool === "boolean" ? props.value.bool : null;

  const handleSelect = (v) => {
    if (props.disabled) return;
    if (v === current) {
      props.onChange(null);
    } else {
      props.onChange({ bool: v });
    }
  };

  const buttonClasses = (isSelected, color) => {
    const base =
      "px-4 py-2 rounded-lg text-sm font-medium border transition-colors";
    if (isSelected) {
      return `${base} bg-${color}-600 border-${color}-600 text-white`;
    }
    return `${base} bg-white border-slate-300 text-slate-700 ${
      props.disabled ? "cursor-not-allowed opacity-60" : "hover:border-violet-400"
    }`;
  };

  return (
    <div className="flex gap-2">
      <button
        type="button"
        onClick={() => handleSelect(true)}
        disabled={props.disabled}
        className={
          current === true
            ? "px-4 py-2 rounded-lg text-sm font-medium bg-emerald-600 border border-emerald-600 text-white"
            : "px-4 py-2 rounded-lg text-sm font-medium bg-white border border-slate-300 text-slate-700 hover:border-violet-400 disabled:opacity-60 disabled:cursor-not-allowed"
        }
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => handleSelect(false)}
        disabled={props.disabled}
        className={
          current === false
            ? "px-4 py-2 rounded-lg text-sm font-medium bg-slate-600 border border-slate-600 text-white"
            : "px-4 py-2 rounded-lg text-sm font-medium bg-white border border-slate-300 text-slate-700 hover:border-violet-400 disabled:opacity-60 disabled:cursor-not-allowed"
        }
      >
        No
      </button>
    </div>
  );
}

export default YesNoFieldRenderer;
